import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TaskNewComponent } from './task-new.component';

const routes: Routes = [{ path: '', component: TaskNewComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TaskNewRoutingModule { }
